import { createFileRoute } from "@tanstack/react-router";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "@/components/www/sections/scaffold";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/_www/datenschutz")({
  component: RouteComponent,
  head: () =>
    seo({
      title: "Datenschutz – Alte Papierfabrik Wuppertal",
      description: "Datenschutzerklärung der Alten Papierfabrik Wuppertal.",
      path: "/datenschutz",
    }),
});

function RouteComponent() {
  return (
    <ScaffoldSection className="md:pt-24">
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle className="hyphens-auto">
            Datenschutzerklärung
          </ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <section className="prose prose-invert max-w-full px-4">
            <h3>1. Datenschutz auf einen Blick</h3>
            <h3>Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber,
              was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere
              Website besuchen. Personenbezogene Daten sind alle Daten, mit
              denen Sie persönlich identifiziert werden können. Ausführliche
              Informationen zum Thema Datenschutz entnehmen Sie unserer unter
              diesem Text aufgeführten Datenschutzerklärung.
            </p>
            <h3>Datenerfassung auf unserer Website</h3>
            <p>
              <strong>
                Wer ist verantwortlich für die Datenerfassung auf dieser
                Website?
              </strong>
            </p>
            <p>
              Die Datenverarbeitung auf dieser Website erfolgt durch den
              Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum
              dieser Website entnehmen.
            </p>
            <p>
              <strong>Wie erfassen wir Ihre Daten?</strong>
            </p>
            <p>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
              mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in
              ein Kontaktformular eingeben.
            </p>
            <p>
              Andere Daten werden automatisch beim Besuch der Website durch
              unsere IT-Systeme erfasst. Das sind vor allem technische Daten
              (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des
              Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch,
              sobald Sie unsere Website betreten.
            </p>
            <p>
              <strong>Wofür nutzen wir Ihre Daten?</strong>
            </p>
            <p>
              Ein Teil der Daten wird erhoben, um eine fehlerfreie
              Bereitstellung der Website zu gewährleisten. Andere Daten können
              zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>
            <p>
              <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong>
            </p>
            <p>
              Sie haben jederzeit das Recht unentgeltlich Auskunft über
              Herkunft, Empfänger und Zweck Ihrer gespeicherten
              personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht,
              die Berichtigung, Sperrung oder Löschung dieser Daten zu
              verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz
              können Sie sich jederzeit unter der im Impressum angegebenen
              Adresse an uns wenden. Des Weiteren steht Ihnen ein
              Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
            <h3>Analyse-Tools und Tools von Drittanbietern</h3>
            <p>
              Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch
              ausgewertet werden. Das geschieht vor allem mit Cookies und mit
              sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens
              erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu
              Ihnen zurückverfolgt werden. Sie können dieser Analyse
              widersprechen oder sie durch die Nichtbenutzung bestimmter Tools
              verhindern. Detaillierte Informationen dazu finden Sie in der
              folgenden Datenschutzerklärung.
            </p>
            <p>
              Sie können dieser Analyse widersprechen. Über die
              Widerspruchsmöglichkeiten werden wir Sie in dieser
              Datenschutzerklärung informieren.
            </p>
            <h3>2. Allgemeine Hinweise und Pflichtinformationen</h3>
            <h3>Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
              Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
              vertraulich und entsprechend der gesetzlichen
              Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            <p>
              Wenn Sie diese Website benutzen, werden verschiedene
              personenbezogene Daten erhoben. Personenbezogene Daten sind Daten,
              mit denen Sie persönlich identifiziert werden können. Die
              vorliegende Datenschutzerklärung erläutert, welche Daten wir
              erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu
              welchem Zweck das geschieht.
            </p>
            <p>
              Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B.
              bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen
              kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
              Dritte ist nicht möglich.
            </p>
            <h3>Hinweis zur verantwortlichen Stelle</h3>
            <p>
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser
              Website ist:
            </p>
            <p>
              TOMA 1807 GmbH &amp; Co KG
              <br /> Friedrich - Ebert - Str. 130
              <br /> 42117 Wuppertal
            </p>
            <p>
              Telefon: 0202 / 3179995
              <br /> E-Mail:
              <span className="cloaked_email">info@altepapierfabrik.eu</span>
            </p>
            <p>
              Verantwortliche Stelle ist die natürliche oder juristische Person,
              die allein oder gemeinsam mit anderen über die Zwecke und Mittel
              der Verarbeitung von personenbezogenen Daten (z.B. Namen,
              E-Mail-Adressen o. Ä.) entscheidet.
            </p>
            <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p>
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
              Einwilligung möglich. Sie können eine bereits erteilte
              Einwilligung jederzeit widerrufen. Dazu reicht eine formlose
              Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum
              Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
              unberührt.
            </p>
            <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
            <p>
              Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein
              Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist
              der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser
              Unternehmen seinen Sitz hat. Eine Liste der
              Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem
              Link entnommen werden:{" "}
              <a
                href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
                rel="noopener"
                target="_blank"
              >
                https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html
              </a>
              .
            </p>
            <h3>Recht auf Datenübertragbarkeit</h3>
            <p>
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer
              Einwilligung oder in Erfüllung eines Vertrags automatisiert
              verarbeiten, an sich oder an einen Dritten in einem gängigen,
              maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die
              direkte Übertragung der Daten an einen anderen Verantwortlichen
              verlangen, erfolgt dies nur, soweit es technisch machbar ist.
            </p>
            <h3>SSL- bzw. TLS-Verschlüsselung</h3>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
              Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
              oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine
              SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
              erkennen Sie daran, dass die Adresszeile des Browsers von
              “http://” auf “https://” wechselt und an dem Schloss-Symbol in
              Ihrer Browserzeile.
            </p>
            <p>
              Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
              Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
              werden.
            </p>
            <h3>Auskunft, Sperrung, Löschung</h3>
            <p>
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
              jederzeit das Recht auf unentgeltliche Auskunft über Ihre
              gespeicherten personenbezogenen Daten, deren Herkunft und
              Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht
              auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu
              sowie zu weiteren Fragen zum Thema personenbezogene Daten können
              Sie sich jederzeit unter der im Impressum angegebenen Adresse an
              uns wenden.
            </p>
            <h3>Widerspruch gegen Werbe-Mails</h3>
            <p>
              Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
              Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
              Werbung und Informationsmaterialien wird hiermit widersprochen.
              Die Betreiber der Seiten behalten sich ausdrücklich rechtliche
              Schritte im Falle der unverlangten Zusendung von
              Werbeinformationen, etwa durch Spam-E-Mails, vor.
            </p>
            <h3>3. Datenschutzbeauftragter</h3>
            <h3>Gesetzlich vorgeschriebener Datenschutzbeauftragter</h3>
            <p>
              Wir haben für unser Unternehmen einen Datenschutzbeauftragten
              bestellt.
            </p>
            <p>
              Gerald Reske
              <br /> Friedrich-Ebert-Str. 130
              <br /> 42117 Wuppertal
            </p>
            <p>
              Telefon: 0202 / 317 99 95
              <br /> E-Mail:
              <span className="cloaked_email">info@sport-park.de</span>
            </p>
            <h3>4. Datenerfassung auf unserer Website</h3>
            <h3>Cookies</h3>
            <p>
              Die Internetseiten verwenden teilweise so genannte Cookies.
              Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten
              keine Viren. Cookies dienen dazu, unser Angebot
              nutzerfreundlicher, effektiver und sicherer zu machen. Cookies
              sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und
              die Ihr Browser speichert.
            </p>
            <p>
              Die meisten der von uns verwendeten Cookies sind so genannte
              “Session-Cookies”. Sie werden nach Ende Ihres Besuchs automatisch
              gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert
              bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren
              Browser beim nächsten Besuch wiederzuerkennen.
            </p>
            <p>
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen
              von Cookies informiert werden und Cookies nur im Einzelfall
              erlauben, die Annahme von Cookies für bestimmte Fälle oder
              generell ausschließen sowie das automatische Löschen der Cookies
              beim Schließen des Browser aktivieren. Bei der Deaktivierung von
              Cookies kann die Funktionalität dieser Website eingeschränkt sein.
            </p>
            <p>
              Cookies, die zur Durchführung des elektronischen
              Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von
              Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) erforderlich
              sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
              gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse
              an der Speicherung von Cookies zur technisch fehlerfreien und
              optimierten Bereitstellung seiner Dienste. Soweit andere Cookies
              (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert
              werden, werden diese in dieser Datenschutzerklärung gesondert
              behandelt.
            </p>
            <h3>Server-Log-Dateien</h3>
            <p>
              Der Provider der Seiten erhebt und speichert automatisch
              Informationen in so genannten Server-Log-Dateien, die Ihr Browser
              automatisch an uns übermittelt. Dies sind:
            </p>
            <ul>
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p>
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird
              nicht vorgenommen.
            </p>
            <p>
              Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f
              DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags
              oder vorvertraglicher Maßnahmen gestattet.
            </p>
            <h3>Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden
              Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort
              angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für
              den Fall von Anschlussfragen bei uns gespeichert. Diese Daten
              geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p>
              Die Verarbeitung der in das Kontaktformular eingegebenen Daten
              erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung
              (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung
              jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per
              E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
              Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
            </p>
            <p>
              Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei
              uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
              Speicherung widerrufen oder der Zweck für die Datenspeicherung
              entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage).
              Zwingende gesetzliche Bestimmungen – insbesondere
              Aufbewahrungsfristen – bleiben unberührt.
            </p>
            <h3>5. Analyse Tools und Werbung</h3>
            <h3>Google reCAPTCHA</h3>
            <p>
              Wir nutzen “Google reCAPTCHA” (im Folgenden “reCAPTCHA”) auf
              unseren Websites. Anbieter ist die Google Inc., 1600 Amphitheatre
              Parkway, Mountain View, CA 94043, USA (“Google”).
            </p>
            <p>
              Mit reCAPTCHA soll überprüft werden, ob die Dateneingabe auf
              unseren Websites (z.B. in einem Kontaktformular) durch einen
              Menschen oder durch ein automatisiertes Programm erfolgt. Hierzu
              analysiert reCAPTCHA das Verhalten des Websitebesuchers anhand
              verschiedener Merkmale. Diese Analyse beginnt automatisch, sobald
              der Websitebesucher die Website betritt. Zur Analyse wertet
              reCAPTCHA verschiedene Informationen aus (z.B. IP-Adresse,
              Verweildauer des Websitebesuchers auf der Website oder vom Nutzer
              getätigte Mausbewegungen). Die bei der Analyse erfassten Daten
              werden an Google weitergeleitet.
            </p>
            <p>
              Die reCAPTCHA-Analysen laufen vollständig im Hintergrund.
              Websitebesucher werden nicht darauf hingewiesen, dass eine Analyse
              stattfindet.
            </p>
            <p>
              Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
              f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse
              daran, seine Webangebote vor missbräuchlicher automatisierter
              Ausspähung und vor SPAM zu schützen.
            </p>
            <p>
              Weitere Informationen zu Google reCAPTCHA sowie die
              Datenschutzerklärung von Google entnehmen Sie folgenden Links:{" "}
              <a
                href="https://www.google.com/intl/de/policies/privacy/"
                rel="noopener"
                target="_blank"
              >
                https://www.google.com/intl/de/policies/privacy/
              </a>{" "}
              und{" "}
              <a
                href="https://www.google.com/recaptcha/intro/android.html"
                rel="noopener"
                target="_blank"
              >
                https://www.google.com/recaptcha/intro/android.html
              </a>
              .
            </p>
            <h3>6. Plugins und Tools</h3>
            <h3>Google Web Fonts</h3>
            <p>
              Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
              so genannte Web Fonts, die von Google bereitgestellt werden. Beim
              Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in
              ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
            </p>
            <p>
              Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung
              zu den Servern von Google aufnehmen. Hierdurch erlangt Google
              Kenntnis darüber, dass über Ihre IP-Adresse unsere Website
              aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt im
              Interesse einer einheitlichen und ansprechenden Darstellung
              unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im
              Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
            </p>
            <p>
              Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine
              Standardschrift von Ihrem Computer genutzt.
            </p>
            <p>
              Weitere Informationen zu Google Web Fonts finden Sie unter{" "}
              <a
                href="https://developers.google.com/fonts/faq"
                rel="noopener"
                target="_blank"
              >
                https://developers.google.com/fonts/faq
              </a>{" "}
              und in der Datenschutzerklärung von Google:{" "}
              <a
                href="https://www.google.com/policies/privacy/"
                rel="noopener"
                target="_blank"
              >
                https://www.google.com/policies/privacy/
              </a>
              .
            </p>
            <h3>OpenStreetMap</h3>
            <p>
              Wir nutzen den Kartendienst von OpenStreetMap (OSM). Anbieterin
              ist die Open-Street-Map Foundation (OSMF), 132 Maney Hill Road,
              Sutton Coldfield, West Midlands, B72 1JU, United Kingdom.
            </p>
            <p>
              Wenn Sie eine Website besuchen, auf der OpenStreetMap eingebunden
              ist, werden u. a. Ihre IP-Adresse und weitere Informationen über
              Ihr Verhalten auf dieser Website an die OSMF weitergeleitet.
              OpenStreetMap speichert hierzu unter Umständen Cookies in Ihrem
              Browser. Das sind Textdateien, die auf Ihrem Computer gespeichert
              werden und die eine Analyse der Benutzung der Website durch Sie
              ermöglichen. Sie können die Speicherung der Cookies durch eine
              entsprechende Einstellung Ihrer Browser-Software verhindern; wir
              weisen Sie jedoch darauf hin, dass Sie in diesem Fall
              gegebenenfalls nicht sämtliche Funktionen dieser Website
              vollumfänglich werden nutzen können.
            </p>
            <p>
              Ferner kann Ihr Standort erfasst werden, wenn Sie dies in Ihren
              Geräteeinstellungen – z. B. auf Ihrem Handy – zugelassen haben.
              Der Anbieter dieser Seite hat keinen Einfluss auf diese
              Datenübertragung. Details entnehmen Sie der Datenschutzerklärung
              von OpenStreetMap unter folgendem Link:{" "}
              <a href="https://wiki.openstreetmap.org/wiki/Privacy_Policy">
                https://wiki.openstreetmap.org/wiki/Privacy_Policy
              </a>
              .
            </p>
            <p>
              Die Nutzung von OpenStreetMap erfolgt im Interesse einer
              ansprechenden Darstellung unserer Online-Angebote und einer
              leichten Auffindbarkeit der von uns auf der Website angegebenen
              Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6
              Abs. 1 lit. f DSGVO dar.
            </p>
            <p />
            <h3>
              7. Dienste Dritter
              <a name="dritter" />
            </h3>
            <h3>
              Datenschutzerklärung für die Nutzung von Bowling
              Reservierungssytems
            </h3>
            <p>
              Wenn Sie Ihre Daten in unser Formular zur Bowling Reservierung
              eintragen und im Schritt "Zusammenfassung" die Schaltfläche
              "Bestätigen" anklicken, werden Ihre Daten in verschlüsselter Form
              alleine zu dem Zweck der Reservierung an unseren
              Kooperationspartner, die canwell - IT Solutions Freienwalder Str.
              16 DE - 13055 Berlin weitergeleitet, die uns die entsprechende
              Software zur Verfügung stellt.
            </p>
          </section>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
